import * as z from 'zod';

export const leaveRequestFormSchema = z
  .object({
    LeaveCategoryId: z.string().min(1, { message: 'LEAVE_TYPE_REQUIRED' }),
    LeaveType: z.enum(['FullDay', 'HalfDay']).default('FullDay'),
    /** Which half of a half day. */
    HalfDayPart: z.enum(['FirstHalf', 'SecondHalf']).default('FirstHalf'),
    /**
     * A default leave taken from the special TOIL pool (split TOIL rule only). Otherwise the leave
     * sheet uses up weekend TOIL first on its own.
     */
    UseSpecialToil: z.boolean().default(false),
    StartDate: z.string().min(1, { message: 'START_DATE_REQUIRED' }),
    EndDate: z.string().min(1, { message: 'END_DATE_REQUIRED' }),
    Reason: z
      .string()
      .min(1, { message: 'REASON_REQUIRED' })
      .max(500, { message: 'REASON_TOO_LONG' }),
  })
  .refine((data) => data.StartDate <= data.EndDate, {
    message: 'START_DATE_MUST_NOT_BE_AFTER_END_DATE',
    path: ['EndDate'],
  });

export type LeaveRequestFormValues = z.infer<typeof leaveRequestFormSchema>;
